export default class Dropdown {
  constructor() {

    $('.js-dropdown button').on('click', function(e) {
      e.preventDefault();
      const parent = $(e.currentTarget).parent('.js-dropdown');
      parent.toggleClass('is-open');
    });

    $('body').on('click', function(e) {
      $('.js-dropdown').removeClass('is-open');
    });

    $('.js-dropdown').on('click', function(e) {
      e.stopPropagation();
    });

    // change button text
    $('.js-dropdown').each(function(index, el) {
      const current = $(el).find('a[aria-current="page"]').text();
      $(el).children('button').text(current);
    });
  }
}
